import Badge from 'components/badge/Badge';
import { Col, Row } from 'react-bootstrap';
import styled from 'styled-components';
import mediaQuery from 'styles/mediaQuery';
import theme from 'styles/theme';

export const NoUnitsFoundContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
`;

export const AddExtraUnitsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px 0px;

  .form-group {
    margin-bottom: 0;

    & > div {
      padding: 0;
      margin: 0;
    }
  }

  input {
    width: 80px !important;
  }
`;

export const UnitListContainer = styled.div``;

export const UnitRow = styled(Row)`
  padding: 10px 0px;
  border-bottom: 1px solid #e0e0e0;
  margin: 0px;

  &:last-child {
    margin-bottom: 12px;
  }

  .form-group {
    margin-bottom: 0;
    flex: 1;

    > div {
      padding: 0px;
    }
  }

  ${mediaQuery.xs} {
    padding: 10px 10px;
  }
`;

export const UnitNameCol = styled(Col)`
  padding-left: 0px;

  ${mediaQuery.xs} {
    margin-bottom: 10px;
    padding-left: 15px;
  }
`;

export const UnitUidAndStatusCol = styled(Col)`
  padding-right: 0px;
  padding-left: 0px;

  .form-group > div {
    padding-right: 0px;
  }
`;

export const UnitStatusCol = styled(Col)`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;

  padding-right: 0;

  ${mediaQuery.xs} {
    padding-right: 15px;
  }
`;

export const UnitStatus = styled(Badge)<{ $isActive: boolean }>`
  background-color: ${({ $isActive }) =>
    $isActive ? theme.colors.bgGreen : theme.colors.gray600};
  color: #fff;
`;
